import React, { useState, useEffect, useRef } from "react";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { useDispatch, useSelector } from "react-redux";
import { WarningToast } from "../../utils/ShowToast";
import { fetchProducts } from "../../store/Slices/ProductSlice";
import { createNewItemInvoiceApi } from "../../ApiRequests";
import { fetchCustomerInvoice } from "../../store/Slices/CustomerInvoiceSlice";
import { fetchCustomerReturnInvoice } from "../../store/Slices/CustomerReturnInvoiceSlice";

const user = JSON.parse(localStorage.getItem("user"));

const InoviceAddItem = ({
  NewItems,
  setNewItems,
  bgColor,
  OnAdd,
  Loading,
  SelectedCustomerType,
  SelectedCustomer,
  InvoiceId,
  saleType,
  onInvoiceUpdated,
}) => {
  const [itemId, setItemId] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [qty, setQty] = useState("");
  const [code, setCode] = useState("");
  const [amount, setAmount] = useState("");
  const [purchase, setPurchase] = useState("");
  const [type, setType] = useState("");
  const [AddItemLoading, setAddItemLoading] = useState(false);

  const [CurrentItemQty, setCurrentItemQty] = useState("");

  const ItemState = useSelector((state) => state.ItemsState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
    dispatch(fetchCustomers());
  }, [dispatch]);

  useEffect(() => {
    setQty("");
  }, [itemId]);

  useEffect(() => {
    setQty("");
  }, []);

  const itemCodeInputRef = useRef(null); // Ref to focus Item Code input

  // Recalculate amount when qty or price changes
  useEffect(() => {
    if (qty !== "" && price !== "") {
      setAmount(Number(qty) * Number(price));
    } else {
      setAmount("");
    }
  }, [qty, price, setAmount]);

  const handleAddItem = (e) => {
    e.preventDefault();
    if (
      itemId === "" ||
      name === "" ||
      qty === "" ||
      price === "" ||
      amount === ""
    ) {
      WarningToast("Please enter item name / qty / price / amount");
    } else {
      setNewItems([
        ...NewItems,
        {
          itemId: itemId,
          name: name,
          qty: Number(qty),
          unit: type,
          purchase: Number(price),
          price: Number(price),
          amount: Number(amount),
        },
      ]);
      // Reset fields
      setItemId("");
      setName("");
      setCode("");
      setQty("");
      setPrice("");
      setAmount("");
      setCurrentItemQty("");
      if (itemCodeInputRef.current) {
        itemCodeInputRef.current.focus();
      }
    }
  };

  return (
    <form
      className={`flex flex-col gap-y-3 rounded-xl border border-line bg-card shadow-soft p-4 my-2`}
    >
      <div className={`h-1.5 rounded-full ${bgColor || "bg-main"}`} />
      <div className="text-base font-bold text-ink px-1 py-1">
        Add New Item
      </div>
      <div className="flex gap-2 w-full flex-wrap max980:flex-col">
        <div className="grid grid-cols-5 gap-2 w-full">
          <div className="flex flex-col">
            <label className="text-sm text-inkSecondary mb-1">Item Code</label>
            <input
              type="text"
              id="ItemCode"
              list="Item-Code"
              value={code}
              ref={itemCodeInputRef} // ✅ Added here
              onChange={(e) => {
                setCode(e.target.value);
                const currentItem = ItemState.data.find(
                  (dt) =>
                    dt.name.toLowerCase() === e.target.value.toLowerCase() ||
                    dt.code.toLowerCase() === e.target.value.toLowerCase()
                );
                if (currentItem) {
                  setItemId(currentItem._id);
                  setName(currentItem.name);
                  setCode(currentItem.code);
                  setType(currentItem.unit);
                  if (SelectedCustomerType && SelectedCustomerType === 2) {
                    setPrice(currentItem.sale_shop);
                  } else {
                    setPrice(currentItem.sale);
                  }
                  setPurchase(currentItem.purchase);
                  setCurrentItemQty(currentItem.qty);
                } else {
                  setItemId("");
                  setPrice("");
                  setCurrentItemQty("");
                }
              }}
              onBlur={(e) => {
                const currentItem = ItemState.data.find(
                  (dt) => dt.code.toLowerCase() === e.target.value.toLowerCase()
                );
                if (!currentItem) {
                  setItemId("");
                  setPrice("");
                  setCurrentItemQty("");
                }
              }}
              placeholder="Select Item"
              className="px-3 py-2 outline-none rounded-lg border border-line bg-card text-ink text-sm focus:border-main focus:ring-2 focus:ring-main/15 col-span-2 max1000:col-span-1"
            />
          </div>

          <div className="flex flex-col flex-1">
            <label className="text-sm text-inkSecondary mb-1">Item Name</label>
            <input
              type="text"
              list="Item-Name"
              value={name}
              onChange={() => {}}
              disabled
              onBlur={(e) => {
                const currentItem = ItemState.data.find(
                  (dt) => dt.name.toLowerCase() === e.target.value.toLowerCase()
                );
                if (!currentItem) {
                  setItemId("");
                  setPrice("");
                  setCurrentItemQty("");
                }
              }}
              placeholder="Select Item"
              className="px-3 py-2 outline-none bg-card rounded-lg border border-line text-ink text-sm focus:border-main focus:ring-2 focus:ring-main/15 col-span-2 max1000:col-span-1"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-inkSecondary mb-1">Quantity</label>
            <input
              type="number"
              value={qty}
              onChange={(e) => {
                const newQty = e.target.value;
                setQty(newQty);
              }}
              onBlur={(e) => {
                if (
                  Number(e.target.value) > CurrentItemQty &&
                  saleType === "SALE"
                ) {
                  WarningToast(
                    `Quantity must be less than or equal to ${CurrentItemQty}`
                  );
                  setQty("");
                  setAmount("");
                }
              }}
              placeholder={
                CurrentItemQty && itemId ? CurrentItemQty : "Quantity"
              }
              className="px-3 py-2 outline-none rounded-lg border border-line bg-card text-ink text-sm focus:border-main focus:ring-2 focus:ring-main/15 max980:w-full"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm text-inkSecondary mb-1">Unit Price</label>
            <input
              type="number"
              value={price}
              onChange={(e) => {
                setPrice(e.target.value);
                setAmount(Number(qty) * Number(price));
              }}
              className="px-3 py-2 outline-none rounded-lg border border-line bg-card text-ink text-sm focus:border-main focus:ring-2 focus:ring-main/15 max980:w-full"
              placeholder="Unit Price"
            />
          </div>
          <div className="flex flex-col max980:w-full">
            <label className="text-sm text-inkSecondary mb-1">Total Amount</label>
            <input
              type="number"
              value={amount}
              disabled
              className="px-3 py-2 outline-none rounded-lg border border-line bg-card text-ink text-sm focus:border-main focus:ring-2 focus:ring-main/15 w-full"
              placeholder="Total Amount"
            />
          </div>

          <datalist id="Item-Code" className="max-h-[50vh]">
            {ItemState.data &&
              ItemState.data.map((option) => (
                <option key={option._id + "-name"} value={option.name} />
              ))}
            {ItemState.data &&
              ItemState.data.map((option) => (
                <option key={option._id + "-code"} value={option.code} />
              ))}
          </datalist>
        </div>
      </div>
      {!Loading && (
        <button
          type="submit"
          className="bg-main text-white px-4 py-2 rounded-lg hover:bg-mainHover transition-colors ease-in-out duration-200 font-bold text-sm active:scale-[.98]"
          onClick={
            OnAdd
              ? async (e) => {
                  e.preventDefault();
                  setAddItemLoading(true);

                  if (
                    !itemId ||
                    !InvoiceId ||
                    !name ||
                    !qty ||
                    !price ||
                    !amount
                  ) {
                    setAddItemLoading(false);
                    WarningToast("Please enter item name/qty/price/amount");
                    return;
                  }

                  try {
                    const response = await createNewItemInvoiceApi({
                      customerId: SelectedCustomer._id,
                      purchase: purchase,
                      invoiceid: InvoiceId,
                      itemId,
                      name,
                      qty,
                      unit: type,
                      price,
                      amount,
                    });
                    dispatch(fetchCustomerInvoice(SelectedCustomer._id));
                    dispatch(fetchCustomerReturnInvoice(SelectedCustomer._id));
                    onInvoiceUpdated?.();

                    setItemId("");
                    setName("");
                    setCode("");
                    setAmount("");
                    setPrice("");
                    console.log(response);
                  } catch (error) {
                    console.log(error);
                  }
                  setAddItemLoading(false);
                }
              : handleAddItem
          }
        >
          Add
        </button>
      )}
    </form>
  );
};

export default InoviceAddItem;
